/** Cross-tab signal so a read/snooze (or a Novu push) in one tab refetches /pending in others. */
export type AnnouncementEvent = { kind: 'refetch' }

const CHANNEL = 'nova-announcements'

export function publishAnnouncementEvent(event: AnnouncementEvent): void {
  if (typeof BroadcastChannel === 'undefined') return
  let ch: BroadcastChannel | null = null
  try {
    ch = new BroadcastChannel(CHANNEL)
    ch.postMessage(event)
  } catch {
    /* noop */
  } finally {
    ch?.close()
  }
}

/** Returns an unsubscribe function. No-op when BroadcastChannel is unavailable. */
export function subscribeAnnouncementEvents(handler: (e: AnnouncementEvent) => void): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  let ch: BroadcastChannel | null = null
  try {
    ch = new BroadcastChannel(CHANNEL)
  } catch {
    return () => {}
  }
  const listener = (ev: MessageEvent) => handler(ev.data as AnnouncementEvent)
  ch.addEventListener('message', listener)
  return () => {
    ch?.removeEventListener('message', listener)
    ch?.close()
  }
}
